import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { Navigate } from 'react-router';

import { useUser, useUserDispatch } from '../../providers/UserContext';
import { useAuth, useAuthDispatch } from '../../providers/AuthContext';
import {
  SET_AUTH_USER,
  SET_PAGE_TITLE,
  USER_FETCH,
} from '../../providers/actionTypes';
import LoadingMask from '../shared/LoadingMask';
import { createUser, getUser } from '../../actions/user';
import { useApi } from '../../providers/ApiContext';
import { usePageTitleDispatch } from '../../providers/PageTitleContext';

const page_title = 'Authenticate';

const Callback = (): React.JSX.Element => {
  const api = useApi();
  const user = useUser();
  const user_dispatch = useUserDispatch();
  const auth = useAuth();
  const auth_dispatch = useAuthDispatch();
  const [loading, setLoading] = useState(false);

  const pageTitleDispatch = usePageTitleDispatch();

  useEffect(() => {
    pageTitleDispatch({ type: SET_PAGE_TITLE, payload: page_title });
  }, [pageTitleDispatch]);

  useEffect(() => {
    if (auth?.user_manager && auth?.user === undefined) {
      auth.user_manager
        .getUser()
        .then((user) => {
          if (user) {
            auth_dispatch({ type: SET_AUTH_USER, payload: user });
          } else {
            auth.user_manager
              ?.signinRedirectCallback()
              .then((user) => {
                auth_dispatch({ type: SET_AUTH_USER, payload: user });
              })
              .catch((error) => console.log(error));
          }
        })
        .catch((error) => console.log(error));
    }
  }, [auth?.user_manager, auth?.user, auth_dispatch]);

  useEffect(() => {
    if (auth.user && !user?.entity_id && !loading && api) {
      // Check if the JWT token is available
      const token = localStorage.getItem('accqsure_jwt');
      if (!token) {
        return;
      }

      setLoading(true);

      // Small delay to ensure auth context is properly updated
      setTimeout(() => {
        getUser(api)
          .then((result) => {
            user_dispatch({ type: USER_FETCH, payload: result });
          })
          .catch((error) => {
            console.log('get user failed:', error);

            if (error.response?.status === 404) {
              // User doesn't exist, create them
              createUser(api)
                .then((result) => {
                  user_dispatch({ type: USER_FETCH, payload: result });
                })
                .catch((createError) => {
                  console.log('create user failed:', createError);
                  setLoading(false);
                });
            } else {
              console.log('Unexpected error getting user:', error);
              setLoading(false);
            }
          });
      }, 100);
    }
  }, [auth.user, user, user_dispatch, loading, setLoading, api]);

  return (
    <Box sx={{ display: 'flex' }}>
      <LoadingMask />
      {user && user?.entity_id && <Navigate replace to='/' />}
    </Box>
  );
};

export default Callback;
